import React, { useState } from "react";
import { ServicesCard } from "./ServicesCard";

export const ServiceHistoryTabs = ({ data }) => {
  const [step, setStep] = useState("active");

  const handleStep = (step) => {
    setStep(step)
  }

  return (
    <div className="myOrders">
      <div className="myOrdersTab">
        <span
          className={step === "active" ? "myActiveOrder" : ""}
          onClick={() => {
            handleStep("active");
          }}
        >
          جاری
        </span>
        <span
          className={step === "archive" ? "myActiveOrder" : ""}
          onClick={() => {
            handleStep("archive");
          }}
        >
          آرشیو
        </span>
      </div>
      <div>
        {step === "active" ? (
          <ServicesCard type={"active"} />
        ) : (
          <ServicesCard type={"archived"} />
        )}
      </div>
    </div>
  );
};
